<template>
  <div class="hydrogen-layout">
    <div class="content">
      <img
        :src="`${config.publicPath}logo.svg`"
        alt="Nobl9"
        class="content__logo"
      />
      <div class="content__layout-wrapper">
        <router-view
          :tier="tier"
          :awsMarketplaceToken="awsMarketplaceToken"
        ></router-view>
      </div>
    </div>
    <div class="content-aside" v-if="isAsideContentAvailable">
      <router-view name="aside"></router-view>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import { configService } from "@/services/config-service";
import { Tier } from "@/services/onboarding/model/tierName";

@Options({
  props: {
    tier: Tier,
    awsMarketplaceToken: String,
  },
})
export default class Onboarding extends Vue {
  config = configService;

  get isAsideContentAvailable(): boolean {
    return !!this.$route.matched[1]?.components?.aside;
  }
}
</script>

<style lang="scss" scoped>
.hydrogen-layout {
  display: flex;
  height: 100%;
  min-height: 100vh;
}

.content {
  width: 490px;
  min-width: 345px;
  margin: 0 auto;
  padding: 0 20px;
  background: white;

  &__layout-wrapper {
    max-width: 690px;
    margin: 0 auto;
  }

  &__logo {
    margin: 68px 0 32px -22px;
    width: 182px;

    @media (max-width: $breakpoint) {
      display: block;
      margin: 22px auto 12px;
    }
  }
}

.content-aside {
  width: 290px;
  background: var(--secondary-background-color);
  padding: 55px;
  display: flex;
  align-items: center;

  @media (max-width: $breakpoint) {
    display: none;
  }
}
</style>
